import React, { useEffect, useState } from "react";
import { getBlogs } from "../api/api";
import BlogCardComponent from "./BlogCardComponent";
import aboutbanners from "../../assets/images/about-head-banner.jpg";
import { FaChevronRight } from 'react-icons/fa';
import "./Blog.css";

const Blog = () => {
  const [blogs, setBlogs] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const res = await getBlogs();
        if (res?.success && Array.isArray(res?.data)) {
          setBlogs(res.data);
          localStorage.setItem("news", JSON.stringify(res.data));
        } else {
          const cached = localStorage.getItem("news");
          if (cached) setBlogs(JSON.parse(cached));
        }
      } catch (error) {
        console.error("Error fetching blogs:", error);
        const cached = localStorage.getItem("news");
        if (cached) setBlogs(JSON.parse(cached));
      } finally {
        setIsLoading(false);
      }
    };

    fetchBlogs();
  }, []);

  if (isLoading) {
    return (
      <div className="loading-container">
        <div className="spinner" />
      </div>
    );
  }

  return (
    <div className="blogs-scroll-container">
      <div className="bannersec"
        style={{
          backgroundImage: `url(${aboutbanners})`,
        }}>
        <h4>Blog</h4>
        <p>Home <span><FaChevronRight /></span> Blog</p>

      </div>
      <div className="containerall">
        <div className="blogs-container">
          {blogs?.length > 0 ? (
            blogs.map((item, index) => (
              // <div key={item?._id || index}>

              // </div>
              <BlogCardComponent item={item} index={index} />
            ))
          ) : (
            <div className="noBlogdiv">
              <p className="no-blogs-text">No blogs found.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Blog;
